export default __webpack_public_path__ + "static/media/meals_female@2x.3a6ebfc3.png";